import { render, staticRenderFns } from "./SdsSection3ImpurityForm.vue?vue&type=template&id=4bbd2c82&scoped=true"
import script from "./SdsSection3ImpurityForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SdsSection3ImpurityForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SdsSection3ImpurityForm.vue?vue&type=style&index=0&id=4bbd2c82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbd2c82",
  null
  
)

export default component.exports